import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

import { HeaderGral } from '@/store/modules/config'
import Forms from '@/store/modules/forms'
import Company from '@/store/modules/company'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialogMain: {
      dialog: false,
      type: '',
      withWindows: 500,
      title: '',
      body: {}
    },
    dialogAlertMain: {
      dialog: false,
      type: '',
      withWindows: 500,
      title: '',
      body: {}
    },
    objectAccess: {},
    objectCloseAccess: {},
    objects: [],
    object: {},
    objectSeccound: {},
    objectThird: {},
    objectDelete: {},
    objectExport: {},
    reload: {},
    progressEmail: false,
    porcentajeAvaluo: [{ name: '0', val: 0 }, { name: '0.5', val: 0.5 }, { name: '1', val: 1 }]
  },
  getters: {
    get_dialogMain (state) {
      return state.dialogMain
    },
    get_dialogAlertMain (state) {
      return state.dialogAlertMain
    },
    get_objectAccess (state) {
      return state.objectAccess
    },
    get_objectCloseAccess (state) {
      return state.objectCloseAccess
    },
    get_objects (state) {
      return state.objects
    },
    get_object (state) {
      return state.object
    },
    get_objectSeccound (state) {
      return state.objectSeccound
    },
    get_objectThird (state) {
      return state.objectThird
    },
    get_reload (state) {
      return state.reload
    },
    get_calculoBancos (state) {
      return state.calculoBancos
    },
    get_progressEmail (state) {
      return state.progressEmail
    },
    get_porcentajeAvaluo (state) {
      return state.porcentajeAvaluo
    },
    get_objectDelete (state) {
      return state.objectDelete
    },
    get_objectExport (state) {
      return state.objectExport
    }
  },
  mutations: {
    SHOW_DIALOG_MAIN (state, data) {
      state.dialogMain.dialog = true
      state.dialogMain.type = data.type
      state.dialogMain.form = (data.form) ? data.form : 'form'
      state.dialogMain.withWindows = (data.with) ? data.with : 500
      state.dialogMain.title = (data.title) ? data.title : ''
      state.dialogMain.body = (data.body) ? data.body : {}
    },
    HIDDE_DIALOG_MAIN (state) {
      state.dialogMain.dialog = false
      state.dialogMain.type = ''
    },

    SHOW_DIALOG_ALERT_MAIN (state, data) {
      state.dialogAlertMain.dialog = true
      state.dialogAlertMain.type = data.type
      state.dialogAlertMain.form = (data.form) ? data.form : 'form'
      state.dialogAlertMain.withWindows = (data.with) ? data.with : 500
      state.dialogAlertMain.title = (data.title) ? data.title : ''
      state.dialogAlertMain.body = (data.body) ? data.body : {}
    },
    HIDDE_DIALOG_ALERT_MAIN (state) {
      state.dialogAlertMain.dialog = false
      state.dialogAlertMain.type = ''
    },

    SET_PROGRESS_EMAIL (state, data) {
      state.progressEmail = data
    },
    POST_DATA_LOGIN (state, data) {
      state.objectAccess = {}
      state.objectAccess = data
    },
    POST_DATA_LOGOUT (state, data) {
      state.objectCloseAccess = {}
      state.objectCloseAccess = data
    },

    GET_DATA_SERVER_LIST (state, data) {
      state.objects = []
      state.objects.push(...data)
    },
    GET_DATA_SERVER (state, data) {
      state.object = {}
      state.object = data
    },
    GET_DATA_SERVER_SECCOUND (state, data) {
      state.objectSeccound = {}
      state.objectSeccound = data
    },
    GET_DATA_SERVER_THIRD (state, data) {
      state.objectThird = {}
      state.objectThird = data
    },
    DELETE_DATA_SERVER (state, data) {
      state.objects = state.objects.filter(el => el.id !== data.id)
    },
    DELETE_DETAIL_DATA_SERVER (state, data) {
      console.log('DELETE_DETAIL_DATA_SERVER', data)
      state.objectDelete = {}
      state.objectDelete = data
    },

    POST_DATA_EXPORT_SERVER (state, exp) {
      state.objectExport = {}
      state.objectExport = exp
    },

    SET_DATA (state, data) {
      let findobject = -1
      state.objects.map((el, i) => {
        if (el.id === data.id) {
          findobject = i
        }
      })
      if (findobject !== -1) {
        Object.assign(state.objects[findobject], data)
      } else {
        state.objects.push(data)
      }
    },
    SET_RELOAD_DATA (state, data) {
      state.reload = data
    }
  },
  actions: {
    PostServiceLogin ({ commit }, action) {
      axios.post(`${action.url}`, action.data).then(response => {
        commit('POST_DATA_LOGIN', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          } else if (error.response.data.message) {
            Vue.swal({
              type: 'error',
              icon: 'error',
              title: 'Ooops!',
              text: error.response.data.message
            })
          }
        })
    },
    PostServiceLogout ({ commit }, action) {
      const header = HeaderGral()
      axios.get(`${action.url}`, header).then(response => {
        commit('POST_DATA_LOGOUT', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    PostListObjects ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header).then(response => {
        commit('GET_DATA_SERVER_LIST', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    PostObject ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header).then(response => {
        commit('GET_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    PostObjectSeccound ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header).then(response => {
        commit('GET_DATA_SERVER_SECCOUND', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    PostObjectThird ({ commit }, action) {
      const header = HeaderGral()
      axios.post(`${action.url}`, action.data, header).then(response => {
        commit('GET_DATA_SERVER_THIRD', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    PutObject ({ commit }, action) {
      const header = HeaderGral()
      axios.put(`${action.url}`, action.data, header).then(response => {
        commit('GET_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    DeleteObject ({ commit }, action) {
      const header = HeaderGral()
      axios.delete(`${action.url}`, header).then(response => {
        commit('DELETE_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    DeleteDetailObject ({ commit }, action) {
      const header = HeaderGral()
      axios.delete(`${action.url}`, header).then(response => {
        commit('DELETE_DETAIL_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    getUrExporPdftDataServerAction ({ commit }, action) {
      const header = HeaderGral()
      // axios.defaults.headers = header
      axios.get(action.url, header).then(response => {
        commit('POST_DATA_EXPORT_SERVER', response.data)
      }).catch(error => {
        if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    }
  },
  modules: {
    Forms,
    Company
  }
})
